module.exports = __webpack_public_path__ + "static/media/MARKETAMERICA@2x.9dcf2d51.png";